var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7588 20.7591C28.5036 20.7591 29.1073 20.1554 29.1073 19.4106C29.1073 18.6659 28.5036 18.0622 27.7588 18.0622V20.7591ZM4.33168 18.4572C3.80509 18.9838 3.80509 19.8375 4.33168 20.3641L12.913 28.9454C13.4396 29.472 14.2933 29.472 14.8199 28.9454C15.3465 28.4188 15.3465 27.5651 14.8199 27.0385L7.19211 19.4106L14.8199 11.7828C15.3465 11.2562 15.3465 10.4025 14.8199 9.87587C14.2933 9.34928 13.4396 9.34928 12.913 9.87587L4.33168 18.4572ZM27.7588 18.0622H5.28516V20.7591H27.7588V18.0622Z",
    fill: "#242529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.7421V7.21052C4 5.4374 5.4374 4 7.21053 4H31.2895C33.0626 4 34.5 5.4374 34.5 7.21053V31.2895C34.5 33.0626 33.0626 34.5 31.2895 34.5H7.21053C5.4374 34.5 4 33.0626 4 31.2895V27.4368",
    stroke: "#242529",
    strokeWidth: 3.21053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log_out.eb336fad9ec53e853854a8e0ff38797e.svg";
export { ForwardRef as ReactComponent };